import { render, staticRenderFns } from "./menu-doctor.vue?vue&type=template&id=83989542&scoped=true"
import script from "./menu-doctor.vue?vue&type=script&lang=js"
export * from "./menu-doctor.vue?vue&type=script&lang=js"
import style0 from "./menu-doctor.vue?vue&type=style&index=0&id=83989542&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83989542",
  null
  
)

export default component.exports